import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Types
import { IState } from "@/store";
import { ICurrency } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      currencies: (state: IState) => state.constants.currencies
    })
  }
})
export default class CurrenciesStore extends Vue {
  public currencies!: ICurrency[];
  public currenciesLoaded = false;

  public async created() {
    await this.getCurrencies();
    this.currenciesLoaded = true;
  }

  public getCurrencies() {
    return this.$store.dispatch("constants/getCurrencies");
  }

  public getCurrencyCode(currencyId) {
    return _.get(_.find(this.currencies, ["id", currencyId]), "code", "");
  }
}
